export default __webpack_public_path__ + "static/traffic-lead-7-322783d2491b6dfaafedefb7ca01f0f7.jpg";